import React, { FC, useState, useCallback, useContext } from 'react'
import ItemsCarousel from 'react-items-carousel'
import { isMobile, isTablet } from 'react-device-detect'

import history from '../../../history'
import AppContext from '../../../context/appContext'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'

import { AlbumTile } from '../style/AlbumScreenStyle'

import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericRow from '../../../GenericComponents/GenericRow'
import timeIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/time-icon.svg'

import { properSemantic } from '../../../utils/minutesProperSemantic'

import {
  MainPageCarouselBox,
  AlbumCard,
  AlbumName,
  RightArrowButton,
  LeftArrowButton,
  LeftCarouselFadeIn,
} from '../../MainScreen/styles/MainScreenStyles'

interface AlbumCarouselInterface {
  videos: any
  albumName: string
  albumId: number
  challengeMode?: boolean
}

const AlbumCarousel: FC<AlbumCarouselInterface> = ({
  videos,
  albumName,
  albumId,
  challengeMode,
}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const chevronWidth = 40
  const [actualWidth, setActualWidth] = useState(0)
  const appContext = useContext(AppContext)

  // const isFolderUnlocked = (folder: any) => {
  //   let isUnlocked: boolean = false

  //   if (isDemoMode && folder.free_content) {
  //     isUnlocked = true
  //   }

  //   if (!isDemoMode && !folder.is_locked) {
  //     isUnlocked = true
  //   }

  //   return isUnlocked
  // }

  // CORRECT - `useCallback` approach

  return (
    <MainPageCarouselBox>
      <GenericTextSpan
        fSize={'1.75rem'}
        display={'block'}
        tAlign={'left'}
        className={`${appContext.appState.theme == 'light' ? 'light' : ''}`}
        margin={isMobile ? '4% 0 2% 6%' : '4% 0 2% 2%'}
      >
        Treningi
      </GenericTextSpan>
      <div style={{ padding: `0 20px` }} className="carousel-outer-wrapper">
        {/* <LeftCarouselFadeIn /> */}
        {/* <ItemsCarousel
          classes={true}
          requestToChangeActive={setActiveItemIndex}
          activeItemIndex={activeItemIndex}
          numberOfCards={window.innerWidth < 600 ? 1 : isTablet ? 2 : 3}
          gutter={20}
          infiniteLoop={isMobile ? true : false}
          showSlither={isMobile ? false : true}
          leftChevron={
            <LeftArrowButton
              className={`${appContext.appState.theme == 'light' ? 'light' : ''
                }`}
            />
          }
          rightChevron={
            <RightArrowButton
              className={`${appContext.appState.theme == 'light' ? 'light' : ''
                }`}
            />
          }
          outsideChevron={true}
          chevronWidth={chevronWidth}
        > */}
        {videos &&
          videos.videos &&
          videos.videos.map((video: any) => (
            <AlbumTile
              className={video.is_locked ? '' : 'active'}
              onClick={
                video.is_locked
                  ? null
                  : () => {
                      history.push({
                        pathname: `/video/${video.vimeo_video_id}`,
                        state: {
                          albumName: albumName,
                          videoOrder: video.video_order,
                          isIntro: video.is_intro,
                          videoId: video.vimeo_video_id,
                          albumId: albumId,
                          challengeMode: challengeMode,
                          videoName: video.name,
                          isFav: videos.favorite_videos.some(
                            (v: any) => v.video_id === video.vimeo_video_id
                          ),
                        },
                      })
                    }
              }
            >
              <GenericColumn width={'33%'}>
                <GenericIcon
                  borderRadius={'14px'}
                  src={video.pictures.sizes[4].link}
                  width={'100%'}
                  height={window.innerWidth > 1200 ? '12vh' : '10vh'}
                  backgroundSize={'cover'}
                />
              </GenericColumn>
              <GenericColumn
                width={'66%'}
                padding={'3% 5%'}
                align={'flex-start'}
                justify={'space-between'}
                height={'100%'}
              >
                <GenericTextSpan
                  color={'#a1ff68'}
                  display={'block'}
                  width={'100%'}
                  tAlign={'right'}
                  fSize={'0.8rem'}
                >
                  {video.badge
                    ? video.badge
                    : video.is_locked
                    ? 'Niedostępny'
                    : ''}
                </GenericTextSpan>
                <GenericTextSpan
                  fSize={isMobile ? '1.3rem' : '1.1rem'}
                  fWeight={'bold'}
                  tAlign={'left'}
                >
                  {video.name}
                </GenericTextSpan>
                <GenericRow justify={'flex-start'} align={'flex-start'}>
                  <GenericIcon
                    src={timeIcon}
                    width={
                      isMobile && !isTablet
                        ? '3vw'
                        : isTablet
                        ? '1.2vw'
                        : '0.75vw'
                    }
                    height={
                      isMobile && !isTablet
                        ? '3vw'
                        : isTablet
                        ? '1.2vw'
                        : '0.75vw'
                    }
                    margin={'0 5% 0 0'}
                  ></GenericIcon>
                  <GenericTextSpan>
                    {properSemantic(Math.floor(video.duration / 60))}
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>
            </AlbumTile>
          ))}
        {/* <div style={{ height: 200, background: '#EEE' }}>First card</div>
          <div style={{ height: 200, background: '#EEE' }}>Second card</div>
          <div style={{ height: 200, background: '#EEE' }}>Third card</div>
          <div style={{ height: 200, background: '#EEE' }}>Fourth card</div> */}
        {/* </ItemsCarousel> */}
      </div>
    </MainPageCarouselBox>
  )
}

export default AlbumCarousel
